import React, { useState } from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import api from '../../services/api';
import { toast } from 'react-hot-toast';

const TestUserAttributePage: React.FC = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    attribute_name: '',
    attribute_type: 'USER',
    data_type: 'STRING',
    description: '',
    is_required: false
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
        
    try {
      // Check if we have a token
      const token = localStorage.getItem('auth_token');
            
      if (token) {
        console.log('Token preview:', token.substring(0, 50) + '...');
      }
      
      await api.post('/abac/custom-attributes', formData);
      toast.success('User attribute created successfully!');
      
      // Reset form
      setFormData({
        attribute_name: '',
        attribute_type: 'USER',
        data_type: 'STRING',
        description: '',
        is_required: false
      });
      
    } catch (error: any) {
      console.error('Error creating user attribute:', error);
      console.error('Error response:', error.response?.data);
      toast.error(`Failed to create user attribute: ${error.response?.data?.error || error.message}`);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  return (
    <div className="container mx-auto p-6 max-w-2xl">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-[var(--color-surface-text)]">{t('abac.testUserAttributeCreation')}</h1>
        <p className="text-xs text-[var(--color-secondary-text)] mt-2">
          Simple test form to debug user attribute creation
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[var(--color-secondary-text)] mb-1">
            Attribute Name *
          </label>
          <input
            type="text"
            name="attribute_name"
            value={formData.attribute_name}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-[var(--color-border)] rounded-md bg-[var(--color-surface-bg)] text-[var(--color-surface-text)] focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
            placeholder="Enter attribute name"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--color-secondary-text)] mb-1">
            Attribute Type
          </label>
          <select
            name="attribute_type"
            value={formData.attribute_type}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-[var(--color-border)] rounded-md bg-[var(--color-surface-bg)] text-[var(--color-surface-text)] focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
          >
            <option value="USER">User</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--color-secondary-text)] mb-1">
            Data Type
          </label>
          <select
            name="data_type"
            value={formData.data_type}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-[var(--color-border)] rounded-md bg-[var(--color-surface-bg)] text-[var(--color-surface-text)] focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
          >
            <option value="STRING">String</option>
            <option value="NUMBER">Number</option>
            <option value="BOOLEAN">Boolean</option>
            <option value="DATE">Date</option>
            <option value="JSON">JSON</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--color-secondary-text)] mb-1">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 border border-[var(--color-border)] rounded-md bg-[var(--color-surface-bg)] text-[var(--color-surface-text)] focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
            placeholder="Enter description"
          />
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            name="is_required"
            checked={formData.is_required}
            onChange={handleChange}
            className="h-4 w-4 text-[var(--color-info)] focus:ring-[var(--color-info)] border-[var(--color-border)] rounded"
          />
          <label className="ml-2 block text-sm text-[var(--color-surface-text)]">
            Required
          </label>
        </div>

        <div className="flex gap-4">
          <button
            type="submit"
            className="px-4 py-2 bg-[var(--color-info)] text-[var(--color-accent-text)] rounded-md hover:bg-[var(--color-info)]/90 focus:outline-none focus:ring-2 focus:ring-[var(--color-info)]"
          >
            Create User Attribute
          </button>
          <button
            type="button"
            onClick={() => {
              const token = localStorage.getItem('auth_token');
                            alert(`Token exists: ${!!token}\nToken preview: ${token ? token.substring(0, 50) + '...' : 'None'}`);
            }}
            className="px-4 py-2 bg-[var(--color-secondary-text)] text-[var(--color-accent-text)] rounded-md hover:bg-[var(--color-secondary-text)]/90 focus:outline-none focus:ring-2 focus:ring-[var(--color-secondary-text)]"
          >
            Check Token
          </button>
        </div>
      </form>
    </div>
  );
};

export default TestUserAttributePage;



